export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10071.5a571c19.jpg";